import cn from 'clsx';
import { ChangeEventHandler, ReactNode } from 'react';

import s from '@/components/survey/common/ui/styles/CheckList.module.scss';
import CheckMark from '@/public/images/survey/ic-checkmark.svg';

export const CheckList = ({
  children,
  checked,
  value,
  className,
  onChange
}: {
  children: ReactNode;
  checked?: boolean;
  value: string;
  className?: HTMLLabelElement['className'];
  onChange?: ChangeEventHandler<HTMLInputElement>;
}) => {
  return (
    <label
      className={cn(
        s.label,
        {
          [`${s.checked}`]: checked
        },
        className
      )}
    >
      <span className={s.label_text}>{children}</span>
      <span className={s.label_icon}>
        <CheckMark width={28} height={28} />
      </span>
      <input type={'checkbox'} value={value} checked={checked} onChange={onChange} className={s.hide_input} />
    </label>
  );
};

export const CheckListGroup = ({ children }: { children: ReactNode }) => {
  return <div className={s.list_group}>{children}</div>;
};
